import React from "react";
import { AiFillDelete, AiFillPlusCircle } from "react-icons/ai";
import { toast } from "react-toastify";
export default function SingleChoice({
  options,
  AddOptions,
  DeleteOptions,
  ChangeOpitons,
  Error,
  onFocus,
  onEdit = false,
}) {
  if (!!!options) return Error();

  function SizeControl(index) {
    if (options.length > 1) DeleteOptions(index);
    else toast.error("Sorularınızda en az bir şık kalmalıdır.");
  }

  return (
    <>
      <div className="w-full h-full ">
        <div className="p-4 bg-gray-200 rounded-2xl mt-4 flex flex-col items-center justify-center">
          {options.map((element, index) => {
            return (
              <div
                className="flex flex-row items-center justify-center self-center w-full"
                key={index}
              >
                <div className="form-control">
                  <label className="label cursor-pointer">
                    <input
                      type="radio"
                      name="radio-6"
                      className="radio checked:bg-blue-500"
                      defaultChecked={false}
                      disabled={true}
                    />
                  </label>
                </div>
                <input
                  onFocus={onFocus}
                  type="text"
                  name="floating_email"
                  id="floating_email"
                  className="block py-2.5 mr-2 px-0 w-full ml-2  text-sm  text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                  placeholder=" "
                  required
                  value={element}
                  onChange={(e) => ChangeOpitons(e.target.value, index)}
                />
                {!onEdit && (
                  <AiFillDelete
                    size={28}
                    className=" hover:text-gray-400 cursor-pointer "
                    onClick={() => SizeControl(index)}
                  />
                )}
              </div>
            );
          })}

          {!onEdit && (
            <AiFillPlusCircle
              size={30}
              onClick={() => AddOptions("Yeni Seçenek")}
              className="mt-4 hover:text-gray-400 hover:mt-6 cursor-pointer"
            />
          )}
        </div>
      </div>
    </>
  );
}
